import { useState } from "react";
import { useTranslation } from "react-i18next";
import Container from "react-bootstrap/Container";

const TopHeader = () => {
    const [t] = useTranslation("global");
    const [hide, setHide] = useState(false);

    return (
        <div className={`topPageHeader ${hide && "hide"}`}>
            <Container>
                <div className="centerTxt">
                    <div className="billSvg"></div> {t("TopHeader")}
                </div>
                <div onClick={() => setHide(true)} className="closeSvg"></div>
            </Container>
        </div>
    );
};

export default TopHeader;
